import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BackendService } from '../../service/backend.service';
import { UserService } from '../../service/user.service';
import { CardData, CardService } from '../../service/card.service';
import { HeaderComponent } from '../../main/header/header.component';
import { Subscription } from 'rxjs';
import { FormatMinutesPipe } from '../../pipes/format-minutes.pipe';
import { CdrData } from '../../service/cdrs.service';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    FormatMinutesPipe
  ],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss'
})
export class CardComponent implements OnInit {
  card: CardData | null = null;
  cdrs: CdrData[] = [];
  private iccid: string | null = null;
  private userSub?: Subscription;

  constructor(
    private readonly backendService: BackendService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly userService: UserService,
    private readonly cardService: CardService
  ) {
  }

  ngOnInit() {
    console.log('ActivatedRoute snapshot:', this.route.snapshot.url);
    console.log('Params:', this.route.snapshot.params);
    this.route.paramMap.subscribe(params => {
      console.log('ParamMap:', params);
    });
    // log stan zalogowania:
    console.log('Is user logged in:', this.userService.isUserLoggedIn());


    this.userSub = this.userService.userLoggedIn$.subscribe(async user => {
      if (!user) {
        await this.goToDashboard();
        return;
      }
      this.route.paramMap.subscribe(async params => {
        this.iccid = params.get('iccid');
        if (!this.iccid || !this.userService.isUserLoggedIn()) {
          await this.goToDashboard();
          return;
        }
        await this.fetchCard(this.iccid);
      });
    });
  }

  ngOnDestroy() {
    this.userSub?.unsubscribe();
  }

  async fetchCard(iccid: string): Promise<void> {
    const fullCardInfo = await this.cardService.getCardDetails(iccid);
    if (!fullCardInfo || !fullCardInfo.card) {
      console.error(`No card information found for ICCID: ${iccid} => ${JSON.stringify(fullCardInfo)}`);
      await this.goToDashboard();
      return;
    }
    this.card = fullCardInfo.card;
    this.cdrs = fullCardInfo.cdrs || [];
    console.log('card:', {
      ...this.card,
      pin1: '***',
      pin2: '***',
      puk1: '***',
      puk2: '***'
    });
  }

  async goToDashboard() {
    await this.router.navigate(["/"], {replaceUrl: true})
  }

  extend(code: string) {
    // navigates to extend for confirmation.
    this.router.navigate(["/extend", this.iccid, code], {replaceUrl: false})
  }
}
